module.exports = __webpack_public_path__ + "static/media/wistfulsummer.22d18a1b.mp3";